module.exports = __webpack_public_path__ + "aw.1eb0d2cd.svg";